/**
 * Employer cockpit permission keys - must match backend
 */
export type EmployerTeamRole = 'admin' | 'manager' | 'viewer';

/**
 * RBAC-presets (Mijn Belagom — Toegangsbeheer & Rechten).
 * admin:   volledige toegang, incl. financiën en contracten
 * manager: trajecten/milestones/afspraken, géén facturen of cockpit-toegang
 * viewer:  uitsluitend leesrechten op trajecten (Poortwachter-tijdlijnen)
 */
export const EMPLOYER_ROLE_PRESETS: Array<{
  role: EmployerTeamRole;
  label: string;
  description: string;
  permissions: string[];
}> = [
  {
    role: 'admin',
    label: 'Admin',
    description: 'Volledige toegang: financiën, contracten ondertekenen, pools wijzigen',
    permissions: [
      'trajecten', 'afgesloten_dossiers', 'gespreksverslagen', 'samenwerkingen',
      'jaarverslagen', 'documenten', 'facturen', 'geplaatste_opdrachten',
      'professional_zoeken', 'chat', 'toegang_cockpit',
    ],
  },
  {
    role: 'manager',
    label: 'Manager',
    description: 'Trajecten starten, milestones en afspraken inzien — geen toegang tot facturen',
    permissions: [
      'trajecten', 'afgesloten_dossiers', 'gespreksverslagen', 'samenwerkingen',
      'jaarverslagen', 'documenten', 'geplaatste_opdrachten',
      'professional_zoeken', 'chat',
    ],
  },
  {
    role: 'viewer',
    label: 'Viewer',
    description: 'Uitsluitend leesrechten op de anonieme Poortwachter-tijdlijnen',
    permissions: ['trajecten'],
  },
];

export const EMPLOYER_PERMISSION_OPTIONS: Array<{ key: string; label: string }> = [
  { key: 'trajecten', label: 'Trajecten' },
  { key: 'afgesloten_dossiers', label: 'Afgesloten dossiers' },
  { key: 'gespreksverslagen', label: 'Gespreksverslagen' },
  { key: 'samenwerkingen', label: 'Samenwerkingen' },
  { key: 'jaarverslagen', label: 'Jaarverslagen' },
  { key: 'documenten', label: 'Documenten' },
  { key: 'facturen', label: 'Facturen' },
  { key: 'geplaatste_opdrachten', label: 'Geplaatste opdrachten' },
  { key: 'professional_zoeken', label: 'Professional zoeken en opdracht plaatsen' },
  { key: 'chat', label: 'Chat met Professioneel' },
  { key: 'toegang_cockpit', label: 'Toegang cockpit' },
];
